import { useLayoutEffect } from 'react';

const useLockBodyScroll = (lockBodyScroll: boolean) => {
  useLayoutEffect(() => {
    let originalStyle;

    if (lockBodyScroll) {
      originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';
    }

    return () => {
      if (originalStyle) {
        document.body.style.overflow = originalStyle;
      }
    };
  }, [lockBodyScroll]);
};

export { useLockBodyScroll };
